import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

export class LunaConfirm extends React.Component {
    constructor(props) {
        super(props)

        this._isMounted = false

        this.state = {
            showConfirm: false
        } 
    }	

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false 
    }

    componentDidUpdate(prevProps, prevState) {
  	if (this.state.showConfirm && prevState.showConfirm !== this.state.showConfirm) {
    	let self = this
            let obj = this.refs.luna_confirm
    	let _confirm = false  
            $.fancybox.open(
                [{
                    src: obj,
                    type: 'inline'
                }],
                {
                    maxWidth: 350,
                    baseClass: 'luna-confirm-modal',
                    closeTpl: '<button data-fancybox-close class="fancybox-close-small"><i class="icon-close"></i></button>',
                    afterLoad: function() {
                        $(obj).find('.confirm').on('click', function(event) {
                            if ($(event.target).is('.yes')) {
                                _confirm = true
                            } else if ($(event.target).is('.no')) {
                                _confirm = false
                            }
                            $.fancybox.close()
                        })
                    },
                    afterClose: function() {
                        self.onConfirm(_confirm)
                    }          
                }
            )
        }    
    }

    showConfirm() {
        this.setState({showConfirm: true})
    }

    onConfirm(confirm) {
        if (confirm) {
            this.props.onConfirm()
        }
        if (this._isMounted) {
            this.setState({showConfirm: false})    
        }
    }


    render() {  	  
        let mssg = this.props.mssg ? this.props.mssg : 'Do you wish to continue?' 
        // TODO: Set this on props.type
        let trigger = null
        switch (this.props.type) {
            case 'ItemTitleBlockBlue':
                trigger = <button className="btn btn-blue btn-flex" onClick={() => {this.showConfirm()}}><span>Saved</span><i className="icon-favorite_selected"/></button>
                break
            case 'ItemTitleBlockRose':
                trigger = <button className="btn btn-rose btn-flex" onClick={() => {this.showConfirm()}}><span>Saved</span><i className="icon-favorite_selected"/></button>
                break
            default:    
                trigger = <i className="icon-close" onClick={() => {this.showConfirm()}}/> 
                break
        }
        return (
            <div>
                <div className="luna-confirm" ref="luna_confirm" style={{display: 'none'}}>
                    <h1 className="title">{mssg}</h1>
                    <div className="btn-block">
                        <input type="button" className="confirm yes btn btn-rose btn-medium" value="Yes"/>
                        <input type="button" className="confirm no btn btn-medium" value="No"/>
                    </div>
                </div>
                { trigger }
            </div>
        )
    }
}
